import React from 'react';
import { Play, SkipBack, SkipForward } from 'lucide-react';
import { Card } from '../ui/Card';
import { cn } from '../ui/Button';
export function TimelineControls() {
  const dates = Array.from({
    length: 21
  }, (_, i) => {
    const d = new Date(2026, 1, 12 + i); // Feb 12 start
    return {
      day: d.getDate(),
      month: d.toLocaleString('default', {
        month: 'short'
      }).toUpperCase(),
      active: i === 0
    };
  });
  return <div className="absolute bottom-6 left-6 right-6 z-[1000] flex items-end gap-4" data-id="element-1003">
      {/* Controls */}
      <Card className="flex items-center gap-1 p-2 bg-[#111827]/90 backdrop-blur border-slate-700/50 rounded-lg" data-id="element-1004">
        <button className="p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-md transition-colors" data-id="element-1005">
          <SkipBack size={16} data-id="element-1006" />
        </button>
        <button className="p-2 text-white bg-slate-700 hover:bg-slate-600 rounded-md transition-colors" data-id="element-1007">
          <Play size={16} fill="currentColor" data-id="element-1008" />
        </button>
        <button className="p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-md transition-colors" data-id="element-1009">
          <SkipForward size={16} data-id="element-1010" />
        </button>
      </Card>

      {/* Current Time Pill */}
      <div className="absolute bottom-20 left-1/2 -translate-x-1/2" data-id="element-1011">
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#111827]/90 border border-slate-700/50 text-xs font-mono text-slate-200 shadow-lg" data-id="element-1012">
          <span data-id="element-1013">Feb 12, 02:00 AM</span>
          <span className="h-2 w-2 rounded-full bg-[#EC4899] animate-pulse" data-id="element-1014" />
        </div>
      </div>

      {/* Timeline Scrubber */}
      <Card className="flex-1 h-14 bg-[#111827]/90 backdrop-blur border-slate-700/50 flex items-center px-4 overflow-hidden relative" data-id="element-1015">
        {/* Progress Line */}
        <div className="absolute top-0 bottom-0 left-[18px] w-0.5 bg-[#EC4899] z-10" data-id="element-1016">
          <div className="absolute top-0 -left-[3px] w-2 h-2 rounded-full bg-[#EC4899]" data-id="element-1017" />
        </div>

        <div className="flex items-center justify-between w-full pl-6" data-id="element-1018">
          {dates.map((date, i) => <div key={i} className="flex flex-col items-center gap-1 min-w-[32px] cursor-pointer group" data-id="element-1019">
              <div className={cn('h-2 w-0.5 rounded-full transition-colors', date.active ? 'bg-[#EC4899] h-3' : 'bg-slate-700 group-hover:bg-slate-500')} data-id="element-1020" />
              <span className={cn('text-[10px] font-medium leading-none', date.active ? 'text-white' : 'text-slate-500 group-hover:text-slate-400')} data-id="element-1021">
                {date.day}
              </span>
              <span className="text-[8px] text-slate-600 leading-none" data-id="element-1022">
                {date.month}
              </span>
            </div>)}
        </div>
      </Card>
    </div>;
}